import Flex from '@Components/Bases/Flex';
import { useDisclosure } from '@hooks/useDisclosure';
import { Add } from '@mui/icons-material';
import { Box, Button, InputLabel } from '@mui/material';
import { useWatch } from 'react-hook-form';
import ClimateChangeStructureSubcommitteeRemark, {
  SUBCOMMITTEE_REMARK_ID,
} from './ClimateChangeStructureSubcommitteeRemark';
import ClimateChangeStructureSubcommitteeTable from './ClimateChangeStructureSubcommitteeTable/SubcommitteeTable';
import ModalSubcommittees from './ModalSubcommittees/ModalSubcommittees';

const ClimateChangeStructureSubcommittee = () => {
  const [opened, { open, close }] = useDisclosure();

  const { completedSection } = useWatch({
    name: 'climateChangeStructure',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};
  return (
    <>
      <Box width={1} mt={2}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Flex gap={1} alignItems={'center'}>
            <InputLabel required sx={{ fontWeight: 800 }}>
              ระบุกรรมการชุดย่อยที่มีบทบาทในการกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ
            </InputLabel>
            <ClimateChangeStructureSubcommitteeRemark />
          </Flex>
          <Button
            color={'inherit'}
            startIcon={<Add />}
            onClick={open}
            disabled={isCompletedTh || isCompletedEn}
          >
            เพิ่มข้อมูล
          </Button>
        </Flex>
        <ClimateChangeStructureSubcommitteeTable />
        <Box id={SUBCOMMITTEE_REMARK_ID} />
      </Box>
      <ModalSubcommittees open={opened} close={close} mode={'create'} />
    </>
  );
};

export default ClimateChangeStructureSubcommittee;
